<template>
  <div
    id="filter-menu"
    class="col-lg-4 d-lg-block position-top-mobile pb-2"
    :class="getFilterMenuClasses"
    role="form"
    aria-labelledby="filterSection"
  >
    <span v-if="!countSubject" class="visuallyhidden">{{
      $t('org.xStudiesFound', { x: count1 })
    }}</span>
    <span v-else class="visuallyhidden">{{
      $t('org.xStudiesFoundForY', { x: count1, y: countSubject })
    }}</span>
    <span aria-label="Studies with a status of Recruiting filter is applied by default"></span>
    <div id="filter-title" class="panel search-filters py-0">
      <c-filter-header :count="filterItems.length"></c-filter-header>
      <div class="row">
        <div class="col no-gutters p-0">
          <c-filter-pills v-if="showFilterPills" :pills="pills"></c-filter-pills>
          <c-filter-items
            class="cFilterItemsContainer"
            :show-chevrons="showChevrons"
            :items="filterItems"
            :loading="loading"
            @filter-selected="onFilterSelected"
          ></c-filter-items>
          <c-show-results-button v-if="showShowResultsButton"></c-show-results-button>
        </div>
      </div>
    </div>
    <c-filter-footer></c-filter-footer>
  </div>
</template>

<script>
import Header from '@/components/pages/filter/Header'
import Footer from '@/components/pages/filter/Footer'
import { filterItems } from '@/components/pages/filter/filterHelpers'
import FilterItems from '@/components/pages/filter/FilterItems'
import Pills from '@/components/pages/filter/Pills'
import ShowResultsButton from '@/components/pages/filter/ShowResultsButton'
import { addId } from '@/utilities/functions'
import { searchResults } from '@/components/pages/searchResults/SearchResultsHelpers'
import { handleFilterSelected } from '@/views/results/resultsHelpers'


export default {
  components: {
    'c-filter-header': Header,
    'c-filter-footer': Footer,
    'c-filter-items': FilterItems,
    'c-filter-pills': Pills,
    'c-show-results-button': ShowResultsButton,
  },
  props: {
    location: String,
  },
  data: () => ({
    showChevrons: false,
    showFilterPills: false,
    showShowResultsButton: false,
  }),
  computed: {
    filterItems() {
      return filterItems(this)
    },
    getFilterMenuClasses() {
      return this.$store.getters['search/showFilterOnMobile'] ? '' : 'd-none'
    },
    loading() {
      return this.$store.getters['core/apiEndpointIsLoading']({
        method: 'POST',
        url: '/json-params/cd',
      })
    },
    pills() {
      return addId([{ name: this.$t('org.recruiting') }])
    },
    countSubject() {
      const { location, searchTerm } = this
      return `${searchTerm || ''}${location && searchTerm ? ' - ' : ''}${location || ''}`
    },
    searchResults() {
      return searchResults(this)
    },
    count1() {
      return this.searchResults.count
    },
    params() {
      return this.$store.getters['search/params']
    },
    searchTerm() {
      return this.params.query && this.params.query !== '*' ? this.params.query : ''
    },
  },
  methods: {
    onFilterSelected(e) {
      this.$emit('filter-selected', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.cFilterItemsContainer::v-deep {
  li {
    list-style: none;
    background-image: none;
    background-repeat: none;
    background-position: 0;
  }
  ul {
    list-style-type: none;
  }
}
</style>
